export const CONTRACTS = "/api/partnerships/:param/contracts"
export const CONTRACT = "/api/partnerships/:param/contracts/:contractParam"
